<template>
  <div class="form-group">
    <select class="form-control" v-model="selRangeFilter" @change="filterRangeData($event)">
      <option v-for="(d, index) in mcOptions" v-bind:key="d.id+index" :value="index">{{d.value}}</option>
    </select>
  </div>
</template>
<script>
import download from "downloadjs";
export default {
  props: ["rawData", "searchData"],
  data() {
    return {
      rData: [],
      sData: [],
      selRangeFilter: 0,
      mcOptions: [
        { id: 0, value: "All", min: "", max: "" },
        { id: 1, value: "MC > 20000", min: 20000, max: "" },
        { id: 2, value: "5000 <= MC <= 20000", min: 5000, max: 20000 },
        { id: 3, value: "1000 <= MC <= 5000", min: 1000, max: 5000 },
        { id: 4, value: "MC <= 1000", min: "", max: 1000 }
      ]
    };
  },
  created() {
    console.log("tabelId", this.rawData, "Filename", this.searchData);
    this.rData = this.rawData;
    this.sData = this.searchData;
  },
  methods: {
    filterRangeData(event) {
      var ind = event.target.value;
      this.selRangeFilter = this.mcOptions[ind].id;
      if (this.selRangeFilter === 0) {
        this.rData = this.sData;
        return this.rData;
      } else {
        var minRange = this.mcOptions[ind].min;
        var maxRange = this.mcOptions[ind].max;
        this.rData = this.sData.filter(rd => {
          // console.log(rd, this.selRangeFilter);
          if (minRange != "" && maxRange != "") {
            return (
              parseInt(rd["marketCapitalization_latest"]) >=
                parseInt(minRange) &&
              parseInt(rd["marketCapitalization_latest"]) <= parseInt(maxRange)
            );
          } else {
            if (minRange != "") {
              return (
                parseInt(rd["marketCapitalization_latest"]) >=
                parseInt(minRange)
              );
            }
            if (this.maxRange != "") {
              return (
                parseInt(rd["marketCapitalization_latest"]) <=
                parseInt(maxRange)
              );
            }
          }
        });
      }
      // setTimeout(()=>{
      //   this.sortColumn(this.tableFields[2], 2);
      // });
      console.log("McFilter", this.rData);
      this.rawData = this.rData;
      this.update();
    },
    update() {
      this.$emit("updateRawData", this.rData);
    }
  },
  computed: {
    updateR() {
      // return this.rawData = this.rData;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/McFilter.vue